import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ChangeDetectorRef } from "@angular/core";
import { DownloadService } from "src/app/base/services/download.service";
import { FileLoaderService } from "src/app/services/file-loader.service";

@Component({
  selector: "app-documents",
  templateUrl: "./documents.component.html",
  styleUrls: ["./documents.component.scss"],
})
export class DocumentsComponent implements OnInit {
  documents: Array<any> = [];
  opened: string;

  constructor(
    private route: ActivatedRoute,
    private downloadService: DownloadService,
    private fileLoader: FileLoaderService
  ) {
    this.opened = this.route.snapshot.paramMap.get("opened");
  }

  ngOnInit(): void {
    this.loadDocs();
  }

  loadDocs() {
    this.fileLoader.getDocs().subscribe((docs) => {
      this.documents = docs;
    });
  }

  download(
    name: string,
    folder: string,
    year: number,
    month: string,
    id: number,
    ext: string = null,
    path: string = null
  ) {
    if (path) {
      this.downloadService.download(path, name, ext);
    } else {
      this.downloadService.download(
        `${folder}/${year}/${month}/${id}`,
        name,
        ext
      );
    }
  }
}
